import { render, staticRenderFns } from "./List.vue?vue&type=template&id=cad65cfe&"
import script from "./List.vue?vue&type=script&setup=true&lang=ts&"
export * from "./List.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./List.vue?vue&type=style&index=0&id=cad65cfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports